import { Tween } from '@tweenjs/tween.js'
import { createContext } from 'react'

import CameraOptions = google.maps.CameraOptions

export type MapContext = {
  map: google.maps.Map
  panTo: (
    target?: {
      position?: google.maps.LatLng | google.maps.LatLngLiteral | null
      zoom?: number | null
      heading?: number | null
      tilt?: number | null
    },
    duration?: number,
  ) => Tween<CameraOptions> | undefined
}

export const MapContext = createContext<MapContext | null>(null)
